import { Injectable } from '@angular/core';

import { RegexValidatorPatternService } from '../../services/regex-validator-pattern.service';

import {
  ControlValidatorType,
  ControlValidateMoment,
  ControlValidatorError,
  ControlValidator,
  RegexValidatorModel
} from '../../types/validator.types';

@Injectable()
export class RegexControlValidator extends ControlValidator {
  type = ControlValidatorType.RegularExpression;
  validateMoment = ControlValidateMoment.Blur;

  private errorMsg: string;
  constructor(private regexService: RegexValidatorPatternService) {
    super();
  }

  validate(): ControlValidatorError {
    this.error = new ControlValidatorError(false, '');
    let reg: RegExp;
    let validatorModel: RegexValidatorModel;

    if (!this.model) {
      return this.validSuccess();
    }

    // è·åæ ¡éªæ­£å
    if (this.model.name === 'custom') {
      reg = new RegExp(this.model.expression);
      this.errorMsg = this.model.errorMessage;
    } else {
      validatorModel = this.regexService.getValidatorModels().find((s) => s.name === this.model.name);
      if (!validatorModel) {
        return this.validSuccess();
      }
      reg = new RegExp(validatorModel.expression);
      this.errorMsg = validatorModel.errorMessage;
    }
    if (!reg) {
      return this.validSuccess();
    }

    // éªè¯
    const value = this.control.model.value;
    // valueå¼ä¸ºç©ºæ¶ï¼ä¸æ ¡éª
    if (!value && value !== 0) {
      return this.validSuccess();
    }
    const valid = reg.test(value);
    if (!valid) {
      return this.validFail();
    } else {
      if (validatorModel && validatorModel.validate) {
        const error = validatorModel.validate(value);
        if (!error.success) {
          return this.validFail(error.message);
        }
      }
      this.error = new ControlValidatorError(true, '');
    }
    return this.error;
  }

  private validFail(msg?: string): ControlValidatorError {
    this.error.message = msg ? msg : this.errorMsg;
    this.error.success = false;
    return this.error;
  }
  private validSuccess(): ControlValidatorError {
    this.error.message = '';
    this.error.success = true;
    return this.error;
  }
}
